<template>
  <div class="container mt-5 px-2">
    <article class="message is-danger" v-if="!token">
      <div class="message-body">
        You have not signed in yet. Please go back to <a href="/">home page</a> to sign in first.
      </div>
    </article>
    <div v-if="token">
      <div>
        <span class="is-pulled-right">
          <router-link class="button is-text mr-2" v-if="!vendorId && isVendorAdmin" :to="'/inbounds-map/null'">Inbounds on Map</router-link>
          <a v-if="!vendorId && isVendorAdmin" class="button mr-2" @click="openUploadLandedCostsModal">Upload Landed Costs</a>
          <router-link class="button is-pulled-right" v-if="vendorId" :to="'/vendor-inbound/' + vendorId + '/new'">New Inbound Shipment</router-link>
          <a v-if="!vendorId && isVendorAdmin" class="button mr-2" @click="openFreightEstimatesModal">Freight Estimates</a>
        </span>
        

        <h1 v-if="!vendorId" class="title">Inbound shipments</h1>
        <h1 v-if="vendorId" class="title is-size-4">{{vendorName}} inbound shipments</h1>

        <div class="mt-3">
          <div v-if="waiting">
            <span class="icon is-medium is-size-4">
              <i class="fas fa-spinner fa-pulse"></i>
            </span>
          </div>
          <div v-else>
            <div class="columns mt-4">
              <div class="column field mb-0 pb-0">
                <p class="control has-icons-left">
                  <span class="select">
                    <select v-model="timeFilter">
                      <option>Within a year</option>
                      <option>All</option>
                    </select>
                  </span>
                  <span class="icon is-small is-left">
                    <i class="fas fa-filter"></i>
                  </span>
                </p>
              </div>
              <div class="column field  mb-0 pb-0">
                <p class="control has-icons-left">
                  <input class="input" type="text" placeholder="Search" v-model="search">
                  <span class="icon is-small is-left">
                    <i class="fas fa-search"></i>
                  </span>
                </p>
              </div>
            </div>

            <div class="table-container">
            <table class="table is-fullwidth my-table">
              <thead>
                <th>
                  <span class="is-clickable" @click="changeSortOption('id')">Id</span>
                  <span class="icon" v-if="sortOption.field == 'id'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('shipmentNumber')">Shipment#</span>
                  <span class="icon" v-if="sortOption.field == 'shipmentNumber'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('bookingId')">External doc id</span>
                  <span class="icon" v-if="sortOption.field == 'bookingId'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th v-if="!vendorId">
                  <span class="is-clickable" @click="changeSortOption('vendorName')">Vendor</span>
                  <span class="icon" v-if="sortOption.field == 'vendorName'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span><br/>
                  <div class="field header-select">
                    <div class="control">
                      <div class="select">
                        <select v-model="filters.vendor.selected">
                          <option v-for="(vo, i) in filters.vendor.options" :value="vo" :key="'so-'+i">{{vo}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('locationName')">Location</span>
                  <span class="icon" v-if="sortOption.field == 'locationName'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span><br/>
                  <div class="field header-select">
                    <div class="control">
                      <div class="select">
                        <select v-model="filters.location.selected">
                          <option v-for="(lo, i) in filters.location.options" :value="lo" :key="'lo-'+i">{{lo}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('shipmentStatus')">Status</span>
                  <span class="icon" v-if="sortOption.field == 'shipmentStatus'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span><br/>
                  <div class="field header-select">
                    <div class="control">
                      <div class="select">
                        <select v-model="filters.status.selected">
                          <option v-for="(vo, i) in filters.status.options" :value="vo" :key="'so-'+i">{{vo}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('mbl')">MBL</span>
                  <span class="icon" v-if="sortOption.field == 'mbl'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th>
                  <span>Duty entry num</span>
                </th>
                <th>
                  <span>Vessel</span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('containers')">Containers</span>
                  <span class="icon" v-if="sortOption.field == 'containers'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('expectedShippingDate')">Expected shipping</span>
                  <span class="icon" v-if="sortOption.field == 'expectedShippingDate'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('expectedDeliveryDate')">Expected delivery</span>
                  <span class="icon" v-if="sortOption.field == 'expectedDeliveryDate'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('lastModifiedDate')">Last modified</span>
                  <span class="icon" v-if="sortOption.field == 'lastModifiedDate'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
              </thead>
              <tbody>
                <template v-for="(ib, i) in showingIbs">
                  <tr>
                    <td class="id-cell" @click="toggleOpen(ib)">
                      <i class="fas" :class="{'fa-angle-right': !ib.opened, 'fa-angle-down': ib.opened,}"></i>&nbsp;
                      <span>{{ib.id}}</span>
                    </td>
                    <td>{{ib.shipmentNumber}}</td>
                    <td>
                      <router-link :to="vendorId ? ('/vendor-inbound/' + vendorId + '/' + ib.id) : ('/inbound/' + ib.id)">{{ib.bookingId}}</router-link>
                    </td>
                    <td v-if="!vendorId">{{ib.vendorName}}</td>
                    <td>{{ib.locationName}}</td>
                    <td>
                      <span :class="'tag ' + getStatusTag(ib.shipmentStatus)">{{ib.shipmentStatus}}</span>
                    </td>
                    <td>{{ib.mbl}}</td>
                    <td>{{ib.landedCost && ib.landedCost.dutyEntryNum}}</td>
                    <td>{{ib.vessel}}</td>
                    <td>
                      <div v-if="ib.containers" style="width:150px">
                        <div v-for="(c,i) in ib.containers.split(/,|\//)" :key="'ibc-'+i">
                          {{c}}
                        </div>
                      </div>
                    </td>
                    <td>{{ib.expectedShippingDate}}</td>
                    <td>{{ib.expectedDeliveryDate}}</td>
                    <td>{{ib.lastModifiedDate}}</td>
                  </tr>
                  <tr v-if="ib.opened">
                    <td></td>
                    <td :colspan="vendorId ? 7 : 8" class="pb-6">
                      <span v-if="!ib.items" class="icon is-medium is-size-6">
                        <i class="fas fa-spinner fa-pulse"></i>
                      </span>
                      <table v-if="ib.items && ib.totals" class="table is-narrow is-hoverable sub-items-table">
                        <thead>
                          <th>PO</th>
                          <th>Item</th>
                          <th>Name</th>
                          <th>Description</th>
                          <th class="num-cell">Quantity expected</th>
                          <th>Containers</th>
                          <th class="num-cell">Unit price</th>
                          <th class="num-cell">Total price</th>
                          <th class="num-cell">Tarriff %</th>
                          <th class="num-cell">Total Tarriff</th>
                        </thead>
                        <tbody>
                          <tr v-for="(ibi, j) in ib.items" :key="'ib-' + ib.id + '-j-' + j">
                            <td>
                              <span v-if="!ibi.po">{{ ibi.purchaseOrderName }}</span>
                              <router-link v-else :to="vendorId ? ('/vendor-purchase-order/' + vendorId + '/' + ibi.po.id) : ('/purchase-order/' + ibi.po.id)">{{ibi.purchaseOrderName }}</router-link>
                            </td>
                            <td>{{ ibi.itemId }}</td>
                            <td>{{ ibi.shipmentItemName }}</td>
                            <td>{{ ibi.shipmentItemDescription }}</td>
                            <td class="num-cell">{{ ibi.quantityExpected }}</td>
                            <td>{{ ibi.containerInfo.replaceAll(',', ', ') }}</td>
                            <td class="num-cell">{{ ibi.poItem && formatPrice(ibi.poItem.rate) }}</td>
                            <td class="num-cell">{{ ibi.poItem && formatPrice(ibi.poItem.rate * ibi.quantityExpected) }}</td>
                            <td class="num-cell">{{ (ibi.poItem && ibi.tarriff != null) ? ('' + ibi.tarriff + '%') : 'N/A' }}</td>
                            <td class="num-cell">{{ (ibi.poItem && ibi.tarriff != null) ? formatPrice(ibi.poItem.rate * ibi.quantityExpected * ibi.tarriff / 100) : 'N/A' }}</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <th>Total</th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th class="num-cell">{{ (ib.totals && ib.totals.quantity) || '' }}</th>
                            <th></th>
                            <th></th>
                            <th class="num-cell">{{ (ib.totals && ib.totals.amount) ? formatPrice(ib.totals.amount) : '' }}</th>
                            <th></th>
                            <th class="num-cell">{{ (ib.totals && ib.totals.tarriff) ? formatPrice(ib.totals.tarriff) : '' }}</th>
                          </tr>
                        </tfoot>
                      </table>
                    </td>
                  </tr>
                </template>
                
              </tbody>
            </table>
            </div>
          </div>
        </div>
      </div>
      
      <div v-if="error" class="notification is-danger is-light">
        <button class="delete" @click="error=''"></button>
        {{error}}
      </div>

      <upload-landed-costs-modal :opened="uploadLandedCostsModal.opened" :inbounds="inbounds" @closeUploadLandedCostsModal="closeUploadLandedCostsModal" @inboundsUpdated="inboundsUpdated"></upload-landed-costs-modal>
      <freight-estimates-modal :opened="freightEstimatesModal.opened" @closeFreightEstimatesModal="closeFreightEstimatesModal" ></freight-estimates-modal>

    </div>
  </div>
</template>

<script>
import dateFormat from 'dateformat'
import UploadLandedCostsModal from '@/components/modals/UploadLandedCostsModal'
import FreightEstimatesModal from '@/components/modals/FreightEstimatesModal'

export default {
  name: 'Inbounds',
  components: {
    UploadLandedCostsModal,
    FreightEstimatesModal
  },
  data () {
    return {
      error: '',
      waiting: false,
      search: '',
      timeFilter: 'All',
      pos: [],
      inbounds: [],
      sortOption: { field: 'lastModifiedDate', asc: false },
      search: '',
      filters: {
        vendor: {options: [], selected: 'All'},
        status: {options: [], selected: 'All'},
        location: {options: [], selected: 'All'},
      },
      uploadLandedCostsModal: {
        opened: false,
      },
      freightEstimatesModal: {
        opened: false,
      },
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    token () {
      return this.$store.state.user.token
    },
    isVendor () {
      return this.$store.state.user.groups.includes('Vendors')
    },
    isVendorAdmin () {
      return this.$store.state.user.groups.includes('VendorAdmin')
    },
    vendorId () {
      return this.$route.params.vendorId
    },
    vendorName () {
      var myVendors = this.$store.state.config.myVendors
      for (var v of myVendors) {
        if (v.nsId == this.vendorId) {
          return v.companyName
        }
      }
      return ''
    },
    showingIbs () {
      var vm = this
      var timeFilteredIbs = vm.inbounds.filter(ib => {
        if (vm.timeFilter == 'All') {
          return true
        }
        var now = new Date()
        var created = new Date(ib.shipmentCreatedDate || ib.createdAt * 1000)
        var diff = now.getTime() - created.getTime()
        return diff < 365 * 24 * 2400 * 1000
      })
      
      var search = vm.search.trim().toLowerCase()
      var filteredIbs = timeFilteredIbs.filter(p => {
        return p.shipmentNumber.toLowerCase().includes(search) || p.bookingId.toLowerCase().includes(search)
          || p.mbl.toLowerCase().includes(search) || p.vessel.toLowerCase().includes(search)
          || p.vendorName.toLowerCase().includes(search) || p.id.toString().includes(search) || p.containers.toLowerCase().includes(search)
          || (p.landedCost && p.landedCost.dutyEntryNum && p.landedCost.dutyEntryNum.toLowerCase().includes(search))
      })

      filteredIbs = filteredIbs.filter(p => 
        (this.filters.vendor.selected == 'All' || this.filters.vendor.selected == p.vendorName)
        && (this.filters.location.selected == 'All' || this.filters.location.selected == p.locationName)
        && (this.filters.status.selected == 'All' || this.filters.status.selected == p.shipmentStatus)
      )

      var mappedIbs = filteredIbs.map(ib => {
        if (!ib.shipmentCreatedDate) {
          ib.shipmentCreatedDate = dateFormat(new Date(ib.createdAt * 1000) , 'isoDate')
        }
        if (!ib.lastModifiedDate) {
          ib.lastModifiedDate = dateFormat(new Date(ib.updatedAt * 1000) , 'isoDate')
        }
        return ib
      })
      
      var sort = vm.sortOption
      var sortedIbs = mappedIbs.sort((a, b) => {
        var va = a[sort.field]
        var vb = b[sort.field]
        if (va == null || vb == null) {
          if (va) {
            return sort.asc ? 1 : -1
          }
          if (vb) {
            return sort.asc ? -1 : 1
          }
          return 0
        }
        if (sort.field == 'id' ) {
          return sort.asc ? va - vb : vb - va
        }
        return sort.asc ? va.localeCompare(vb) : vb.localeCompare(va)
      })
      return sortedIbs
    },
  },
  watch: {
    vendorId: function (val) {
      if (val) {
        this.getVendorInbounds()
      } else {
        this.getAllInbounds()
      }
    },
  },
  methods: {
    getAllInbounds () {
      this.waiting = true
      this.$http.get(this.server + '/myapp/get-all-inbounds/').then(resp => {
        this.inbounds = resp.body.map(i => {
          i.opened = false
          i.items = null
          i.totals = null
          if (i.draftStatus == 'Draft') {
            if (i.shipmentStatus) {
              i.shipmentStatus = 'Draft-' + i.shipmentStatus
            } else {
              i.shipmentStatus = 'Draft'
            }
          }
          return i
        })
        this.collectFiltersOptions()
        this.waiting = false
      }, err => {
        this.error = err.body
        this.waiting = false
      })
    },
    getVendorInbounds () {
      this.waiting = true
      this.$http.get(this.server + '/myapp/get-vendor-inbounds/' + this.vendorId).then(resp => {
        this.inbounds = resp.body.map(i => {
          i.opened = false
          i.items = null
          i.totals = null
          if (i.draftStatus == 'Draft') {
            if (i.shipmentStatus) {
              i.shipmentStatus = 'Draft-' + i.shipmentStatus
            } else {
              i.shipmentStatus = 'Draft'
            }
          }
          return i
        })
        this.collectFiltersOptions()
        this.waiting = false
      }, err => {
        this.error = err.body
        this.waiting = false
      })
    },
    collectFiltersOptions () {
      var filters = {
        vendor: {options: this.collectOptions('vendorName'), selected: 'All'},
        status: {options: this.collectOptions('shipmentStatus'), selected: 'All'},
        location: {options: this.collectOptions('locationName'), selected: 'All'},
      }
      this.filters = filters
    },
    collectOptions(fieldName) {
      var values = new Set()
      for (var c of this.inbounds) {
        values.add(c[fieldName].trim())
      }
      var vs = Array.from(values)
      vs.sort()
      vs.unshift('All')
      return vs
    },
    toggleOpen (p) {
      p.opened = !p.opened
      if (!p.items) {
        this.$http.get(this.server + '/myapp/get-inbound-items-with-pos/' + p.id).then(resp => {
          p.items = resp.body.map(pi => {
            if (pi.po.locationId == 9) {
              pi.tarriff = pi.poItem.dutyPercentageCanada
            } else {
              pi.tarriff = pi.poItem.dutyPercentage
            }
            return pi
          })
          p.totals = this.computeTotals(p.items)
        })
      }
    },
    computeTotals (items) {
      var totals = {
        quantity: 0,
        amount: 0,
        tarriff: 0,
      }
      for (var item of items) {
        totals.quantity += item.quantityExpected
        totals.amount += (item.poItem && item.poItem.rate) ? (item.poItem.rate * item.quantityExpected) : 0
        totals.tarriff += (item.poItem && item.poItem.tarriff) ? (item.poItem.rate * item.quantityExpected * item.tarriff / 100) : 0
      }
      return totals
    },
    changeSortOption (field) {
      this.sortOption = {
        field: field,
        asc: field == this.sortOption.field ? !this.sortOption.asc : true
      }
    },
    getStatusTag (status) {
      if (status == 'Draft') {
        return 'is-white'
      }
      if (status == 'toBeShipped') {
        return 'is-light'
      }
      if (status == 'inTransit') {
        return 'is-warning'
      }
      if (status == 'partiallyReceived') {
        return 'is-info'
      }
      if (status == 'received') {
        return 'is-success'
      }
      if (status == 'closed') {
        return 'is-dark'
      }
      return 'is-danger'
    },
    formatPrice (value) {
      if (!value) {
        return ''
      }
      return '$' + value.toLocaleString('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        useGrouping: false
      })
    },
    closeUploadLandedCostsModal (result) {
      if (result) {
        this.getAllInbounds()
      }
      this.uploadLandedCostsModal.opened = false
    },
    openUploadLandedCostsModal () {
      this.uploadLandedCostsModal.opened = true
    },
    inboundsUpdated () {
      this.getAllInbounds()
    },
    openFreightEstimatesModal () {
      this.freightEstimatesModal.opened = true
    },
    closeFreightEstimatesModal () {
      this.freightEstimatesModal.opened = false
    },
  },
  mounted () {
    if (this.vendorId) {
      this.getVendorInbounds()
    } else {
      this.getAllInbounds()
    }
  },
}
</script>

<style scoped>
.id-cell {
  min-width: 80px;
  cursor: pointer;
}
.sub-items-table {
  font-size: 0.9em;
}
.num-cell {
  text-align: right !important;
}
.memo-cell {
  word-break: break-all;
}
.header-select {
  max-width: 120px;
}
</style>
